import { defineRule } from 'vee-validate';
import axios from 'axios';


defineRule('organizationCodeUnique', async value => {
	if (value === "") return true;
	try {
        let result = await axios.get(`/api/CheckOrganizationCode?code=${value}`).then(({ data }) => data);
		if(result) return true;
		return `組織代號不可重複`;
	} catch (error) {
		console.error(error)
		return `權限代號唯一判斷錯誤`;
	}
});

